import { Component } from 'react';
import PropTypes from 'prop-types';

class MapsPolygon extends Component {

    constructor(props) {
        super(props);
        
        this.polygon = null;
        this.redraw = this.redraw.bind(this);
        this.editOverlay = this.editOverlay.bind(this);
    }

    componentWillUnmount() {
        if ( this.polygon !== null ) {
            this.polygon.setMap(null);
        }
    }

    redraw() {
        const { coordsArray, currentPlan, setCurrentPlan, setSelectedShape, deleteShape, selectedShape, isDrawed, isEdited } = this.props;
        var polygonColor = '#016DB2';
        var strokeColor = '#FFFCE8'
        if ( window.mapRef === undefined || coordsArray === undefined ) return;

        if( selectedShape !== null && selectedShape !== undefined && selectedShape[0].coordsArray === coordsArray) {
            polygonColor = 'orange'
            strokeColor = 'orange'
        } 
        
        if (this.polygon === null) {
            this.polygon = new window.google.maps.Polygon({
                paths: coordsArray,
                fillColor: polygonColor,
                fillOpacity: 0.5,
                strokeColor: strokeColor,
                strokeWeight: 2,
                map: window.mapRef,
                editable:true,
                zIndex: 1,
            });   
        }
        else {
            this.polygon.setPath(coordsArray);
            this.polygon.setOptions({
                fillColor: polygonColor,
                strokeColor: strokeColor,
            });
        }

        window.google.maps.event.clearInstanceListeners(this.polygon)

        window.google.maps.event.addListener(this.polygon,'click',function(e){
            var obj = currentPlan.shapesArray.filter((obj)=>{
                return obj.coordsArray === coordsArray
            })
            setSelectedShape(obj)
        })

        if ( !isDrawed && !isEdited ){
            this.polygon.setEditable(false)   
        }
        else if ( isDrawed || isEdited ){
            window.google.maps.event.addListener(this.polygon,'rightclick',function(e){
                currentPlan.shapesArray = currentPlan.shapesArray.filter(function( obj ) {
                    if(obj.coordsArray === coordsArray){
                        deleteShape(obj)
                    }
                    return obj.coordsArray !== coordsArray;
                })
                setSelectedShape(null)
                setCurrentPlan(currentPlan)
            })
            
            this.editOverlay()
        }

    }

    editOverlay(){
        const{ coordsArray, setCurrentPlan, currentPlan } = this.props
        this.polygon.setEditable(true)
        window.google.maps.event.addListener(this.polygon.getPath(),'set_at',function(index,obj){
            var newCoordArray = []
            this.j.forEach(latlngs=>{
                var latlng = {lat:latlngs.lat(),lng:latlngs.lng()}
                newCoordArray.push(latlng)
            })
            currentPlan.shapesArray.filter((shape)=>{
                if( shape.coordsArray === coordsArray ){
                    shape.coordsArray = newCoordArray
                }
                return null
            })
            setCurrentPlan(currentPlan)
        })
        window.google.maps.event.addListener(this.polygon.getPath(),'insert_at',function(index,obj){
            var newCoordArray = []
            this.j.forEach(latlngs=>{
                var latlng = {lat:latlngs.lat(),lng:latlngs.lng()}
                newCoordArray.push(latlng)
            })
            currentPlan.shapesArray.filter((shape)=>{
                if( shape.coordsArray === coordsArray ){
                    shape.coordsArray = newCoordArray
                }
                return null
            })
            setCurrentPlan(currentPlan)
        })

    }

    render() {
        this.redraw()
        return null
    }

}

MapsPolygon.propTypes = {
    coordsArray: PropTypes.array
};

export default MapsPolygon;


// WEBPACK FOOTER //
// ./src/PageMaps/_MapsPolygon.js